// extracted by mini-css-extract-plugin
module.exports = {"resultsWrapper":"hits_resultsWrapper__8h3_X","searchHit":"hits_searchHit__VntjO","nextButton":"hits_nextButton__wegRM"};